module.exports = __webpack_public_path__ + "static/media/demuth_letter_under.e41cf924.png";